import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { IconModule, TruncateTextPopoverModule } from '@spartacus/storefront'
import {EbInfoBoxModule} from "../info-box/eb-info-box.module";
import { EbSpinnerModule } from '../spinner/eb-spinner.module'
import { EbCardComponent } from './eb-card.component'

@NgModule({
  declarations: [EbCardComponent],
  exports: [EbCardComponent],
    imports: [CommonModule, IconModule, TruncateTextPopoverModule, EbSpinnerModule, EbInfoBoxModule]
})
export class EbCardModule {}
